export { default as Pricing } from './Pricing';